import { render } from "./CharGötterlichtView.vue?vue&type=template&id=3fa9deb6"
import script from "./CharGötterlichtView.vue?vue&type=script&lang=js"
export * from "./CharGötterlichtView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__